module.exports = require("entity-decode/browser");